import { Emoji } from 'emoji-mart';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { logger } from 'services';

const emojify = (text: string): string => {
  const regex =
    /<span(?:\s[^>]*)?(?:class="[^"]*emoji[^"]*")?(?:\s[^>]*)?>:([a-zA-Z0-9_\-+*]+):<\/span>|:([a-zA-Z0-9_\-+*]+):/g; // Regular expression to match shortcodes

  return text.replace(regex, (match, shortcode) => {
    try {
      if (shortcode == null) {
        if (match != null && match.startsWith(':') && match.endsWith(':')) {
          shortcode = match.split(':').at(1) ?? match;
        } else {
          return match;
        }
      }

      return renderToStaticMarkup(
        <Emoji emoji={shortcode} size={16} key={match} />,
      );
    } catch (e) {
      logger.error('emoji-mart failed to parse emoji', {
        error: e instanceof Error ? e.stack : e,
        emojiShortCode: match,
      });

      return match;
    }
  });
};

export const tryEmojify = (text: string): string => {
  try {
    if (
      text.toLowerCase().includes('http://') ||
      text.toLowerCase().includes('https://')
    ) {
      return text;
    }

    return emojify(text);
  } catch (error) {
    logger.error('emoji-mart failed to parse emoji', {
      error,
      emojiShortCode: text,
    });

    return text;
  }
};
